<div *ngIf="ticketApproval">
  <div class="stick-top">
    <mat-toolbar
      ><mat-icon>local_activity</mat-icon>
      {{
        ticketApproval.id ? "Ticket Approval - " + ticketApproval.name : "Create new Ticket Approval"
      }}</mat-toolbar
    >
    <div class="hbox lightly-padded button-bar">
      <button
        mat-raised-button
        class="primary"
        type="button"
        (click)="save()"
        [disabled]="!form.form.valid"
      >
        <mat-icon>{{ ticketApproval.id ? "save" : "add" }}</mat-icon>
        {{ ticketApproval.id ? "Update" : "Add" }}
      </button>
      <micro-delete-confirm
        *ngIf="ticketApproval.id"
        (onConfirm)="delete()"
      ></micro-delete-confirm>
    </div>
  </div>
  <div class="padded">
    <form #form="ngForm" role="form">
      <table class="basicTable vtable">
        <thead>
          <tr>
            <th colspan="100">Ticket Approval Details</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="auth.isCompanyAdmin()"><th>Company</th><td><micro-company-select [(companyId)]="ticketApproval.companyId" [required]="true"></micro-company-select></td></tr>
          <tr>
            <th>
              <micro-valid-label
                for="name"
                [model]="name"
                label="Name"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #name="ngModel"
                [(ngModel)]="ticketApproval.name"
                required
                maxlength="50"
                id="name"
                name="name"
              />
            </td>
          </tr>
          <tr>
            <th>Event Category</th>
            <td>
              <micro-select-combo
                #sel
                [placeholder]="'Select Event Category'"
                [mode]="'single'"
                [(id)]="ticketApproval.eventCategoryId"
                (idChange)="onEventCategoryChange($event)"
                [options]="eventCategoryOptions"
                [loading]="false"
                [required]="true"></micro-select-combo>
            </td>
          </tr>
          <tr>
            <th>Event Type</th>
            <td>
              <micro-select-combo
                #sel
                [placeholder]="'Select Event Type'"
                [mode]="'single'"
                [(id)]="ticketApproval.eventTypeId"
                (idChange)="onSelectedChange('eventTypeId', $event)"
                [options]="eventTypeOptions"
                [loading]="!ticketApproval.eventCategoryId"
                [required]="true"></micro-select-combo>
            </td>
          </tr>
          <tr><th>Contact Group</th><td><micro-contactGroup-select [(contactGroupId)]="ticketApproval.contactGroupId" [required]="true"></micro-contactGroup-select></td></tr>
          <tr>
            <th [ngClass]="ticketApproval.active !== 'Y' ? 'CRITICAL' : ''">
              <micro-valid-label
                for="active"
                label="Active"
              ></micro-valid-label>
            </th>
            <td>
              <input type="checkbox" [checked]="ticketApproval.active === 'Y'" (change)="onCheckboxChange($event)" id="active" name="active">
            </td>
          </tr>
          <tr>
            <th>
              <micro-valid-label
                for="approvalOrder"
                [model]="approvalOrder"
                label="Approval order"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #approvalOrder="ngModel"
                [(ngModel)]="ticketApproval.approvalOrder"
                required
                id="approvalOrder"
                name="approvalOrder"
                type="number"
                min="1"
              />
            </td>
          </tr>
          <tr>
            <th>
              <micro-valid-label
                for="notes"
                [model]="notes"
                label="Notes"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #notes="ngModel"
                [(ngModel)]="ticketApproval.notes"
                required
                maxlength="200"
                id="notes"
                name="notes"
              />
            </td>
          </tr>
          
        </tbody>
      </table>
    </form>
  </div>
</div>
